import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";
import AppointmentForm from "../../components/Appointments/AppointmentForm";

const AppointmentsEdit = ({classes, appointment, board, uploadConfig, formUrl, redirectAfterSubmit}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('contracts.edit_contract')}
        />

        <Card>
            <CardContent>
                <AppointmentForm
                    values={appointment}
                    board={board}
                    formUrl={formUrl}
                    uploadConfig={uploadConfig}
                    isEdit={true}
                    redirectAfterSubmit={redirectAfterSubmit}
                />
            </CardContent>
        </Card>
    </Layout>
);

export default AppointmentsEdit;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/notes/Edit.jsx